import { SearchIcon, onegrid, twoGrid, ThreeGrid } from '../../../../assets/Icons/icons';

const VIEW_MODES = [
  { mode: 'three', icon: ThreeGrid, label: 'Three Columns' },
  { mode: 'two',   icon: twoGrid,   label: 'Two Columns'   },
  { mode: 'one',   icon: onegrid,   label: 'Single Column' },
];

const RequestToolbar = ({
  searchTerm,
  onSearch,
  sortBy,
  onSort,
  viewMode,
  onViewChange,
  totalResults,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 mb-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex flex-col sm:flex-row items-stretch md:items-center gap-4 flex-1">
          {/* Search */}
          <div className="relative flex-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
              <SearchIcon className="h-5 w-5" />
            </div>
            <input
              type="text"
              placeholder="Search requests..."
              value={searchTerm}
              onChange={onSearch}
              className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary text-sm shadow-sm transition-all"
            />
          </div>

          <div className="relative w-full sm:w-auto">
            <select
              value={sortBy}
              onChange={(e) => onSort(e.target.value)}
              className="appearance-none w-full sm:min-w-[160px] bg-white border border-gray-300 rounded-lg px-4 py-2.5 pr-10 text-sm focus:ring-2 focus:ring-primary focus:border-primary shadow-sm cursor-pointer transition-all"
            >
              <option value="all">All Request</option>
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none border-l border-gray-200 my-2">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        {/* ── Right: Result count + View toggle ── */}
        <div className="flex flex-row items-center justify-between md:justify-end gap-6 border-t md:border-t-0 border-gray-100 pt-4 md:pt-0">
          <div className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="text-sm font-semibold text-gray-900">
              {totalResults}
            </span>
            <span className="text-sm text-gray-500">
              {totalResults === 1 ? 'request' : 'requests'}
            </span>
          </div>

          <div className="flex bg-gray-100/80 rounded-lg p-1 shrink-0">
            {VIEW_MODES.map(({ mode, icon, label }) => (
              <button
                key={mode}
                onClick={() => onViewChange(mode)}
                className={`p-1.5 rounded-md transition-all duration-200 ${
                  viewMode === mode
                    ? 'bg-white text-primary shadow-sm scale-105'
                    : 'text-gray-400 hover:text-gray-600'
                } ${mode !== 'one' ? 'hidden md:flex' : 'flex'}`}
                title={label}
              >
                <img src={icon} alt={label} className="w-4 h-4" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestToolbar;
